module.exports = __webpack_public_path__ + "img/user-15.8dd8640f.svg";